import React from "react";
import { useSelector } from "react-redux";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";

const TableChart = () => {
  const {
    data_table: { rows = [], cols = [] },
    options
  } = useSelector((state) => state.activeClients.tableChartData);

  return (
    <GoogleChart
      columns={cols}
      rows={rows}
      options={options}
      chartName="attendance_active_clients_table_chart"
      width="1350px"
      enableEventListeners={false}
      showCurrency={false}
      chartType="Table"
    />
  );
};

export default TableChart;
